import React from 'react';
import { Coins, Eye, Sparkles } from 'lucide-react';
import { formatEuro } from './liveTheme';

export const LiveAfterShowCard = ({ session, lang, onReturn, onReplay }) => {
  if (!session) return null;

  return (
    <section data-testid="pulse-live-after-show" className="rounded-2xl bg-[#111] border border-white/8 p-5 md:p-6">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-5">
        <div>
          <p className="text-[10px] uppercase tracking-widest text-white/25 mb-2">{lang === 'es' ? 'Fin' : 'Ended'}</p>
          <h3 className="text-2xl font-bold text-white">{session.title}</h3>
          <p className="text-sm text-white/40 mt-1">{session.artist_name}</p>
        </div>
        <div className="flex items-center gap-4 text-sm text-white/40">
          <span className="flex items-center gap-1.5"><Eye size={14} /> {session.viewers || 0}</span>
          <span className="flex items-center gap-1.5"><Coins size={14} /> {formatEuro(session.total_donations || 0)}</span>
          <span className="flex items-center gap-1.5"><Sparkles size={14} /> {session.social_power || 0}</span>
        </div>
      </div>
      <div className="mt-5 flex gap-3">
        <button data-testid="pulse-live-after-show-return" onClick={onReturn} className="rounded-full bg-white/5 border border-white/10 px-5 py-2.5 text-sm text-white/60 hover:text-white transition">
          {lang === 'es' ? 'Volver' : 'Back'}
        </button>
        <button data-testid="pulse-live-after-show-replay" onClick={onReplay} className="rounded-full bg-white text-black px-5 py-2.5 text-sm font-semibold hover:bg-white/90 transition">
          {lang === 'es' ? 'Repetir' : 'Replay'}
        </button>
      </div>
    </section>
  );
};
